import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { WheelTab } from "@/sections/WheelTab";
import { ChoresTab } from "@/sections/ChoresTab";
import { CalendarTab } from "@/sections/CalendarTab";
import { WalletTab } from "@/sections/WalletTab";
import { FunTab } from "@/sections/FunTab";
import { ManageTab } from "@/sections/ManageTab";

const TABS = [
  { id: "wheel", label: "Chore Wheel", icon: "🎡" },
  { id: "chores", label: "My Chores", icon: "🧹" },
  { id: "calendar", label: "Calendar", icon: "📅" },
  { id: "wallet", label: "Wallet", icon: "💰" },
  { id: "fun", label: "Family Fun", icon: "🍫" },
  { id: "manage", label: "Manage", icon: "⚙️", parentOnly: true },
];

export default function Dashboard() {
  const { activeMember, isParent, refreshMembers } = useAuth();
  const [tab, setTab] = useState("wheel");
  const onData = () => refreshMembers();

  const visibleTabs = TABS.filter((t) => !t.parentOnly || isParent);

  return (
    <div className="App min-h-screen">
      <Navbar />

      {/* tab bar */}
      <div className="sticky top-[65px] z-30 bg-[#faf8f5]/90 backdrop-blur border-b border-slate-900/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2 flex gap-1.5 overflow-x-auto">
          {visibleTabs.map((t) => (
            <button
              key={t.id}
              data-testid={`tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`whitespace-nowrap px-4 py-2 rounded-xl font-bold text-sm transition-all ${
                tab === t.id ? "bg-slate-900 text-white" : "text-slate-500 hover:bg-slate-100"
              }`}
            >
              <span className="mr-1">{t.icon}</span>{t.label}
            </button>
          ))}
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-6 sm:py-8">
        {!activeMember && (
          <div className="card-tactile p-6 mb-6 text-center font-bold text-slate-500">
            👆 Pick who you are up top to get started!
          </div>
        )}
        {tab === "wheel" && <WheelTab onData={onData} />}
        {tab === "chores" && <ChoresTab onData={onData} />}
        {tab === "calendar" && <CalendarTab />}
        {tab === "wallet" && <WalletTab onData={onData} />}
        {tab === "fun" && <FunTab onData={onData} />}
        {tab === "manage" && isParent && <ManageTab onData={onData} />}
      </main>
    </div>
  );
}
